
import { createReducer } from 'redux-act';
import update from 'immutability-helper';

import { set_loaded_people } from '../actions';

export default createReducer({
	[set_loaded_people]: 
		(state, payload) => update(state, { loaded: { $set: payload } }),
}, { loaded: [] });
